import { createComponent } from '@carvana/merch-components';
import { EvGuideSection, Title } from '../../styles';

export const SectionWrapper = createComponent(EvGuideSection, {
  className: '!max-w-full bg-canvas-muted lg:!px-[84px]'
});

export const SectionTitle = createComponent(Title, {
  className: 'mb-2xl sm:mb-4xl'
});

export const GridWrapper = createComponent('div', {
  className: 'grid gap-2xl md:grid-cols-3'
});

export const CardWrapper = createComponent('div', {
  className:
    'flex flex-col items-start rounded-lg bg-background-default p-2xl sm:p-3xl'
});

export const CardTitle = createComponent('p', {
  className: 'mb-md mt-lg text-text-strong t-heading-lg sm:mt-2xl'
});

export const CardContent = createComponent('p', {
  className: 'text-text-default t-body-md'
});
